import { Image, Button } from "@chakra-ui/react";
import { onboard } from "./config";
import { useConnectWallet } from '@web3-onboard/react';

export const LargeConnect = () => {
  const [{ wallet }, connect] = useConnectWallet();

  const handleConnectWallet = () => {
    connect();
    const state = onboard.state.get();
    state.accountCenter.enabled = false;
  }

  return (
    <>
      {!wallet ?
        <Button onClick={handleConnectWallet} bg={"transparent"} _hover={{bg: "transparent"}} _focus={{border: "none"}} _active={{transform: "scale(.95)"}}>
          <Image alt='' width={350} src={"./images/largeConnect.svg"} style={{cursor: "pointer"}} />        
        </Button>
        :
        null
      }
    </>
  )
}